import { useSelector, useDispatch } from 'react-redux'
import { set, unSet } from "../store/selectedLocation/selectedLocationSlice";
import { clearOnLocalStorage, getFromLocalStorage, setOnLocalStorage } from '../utils/selected-branch-locations';

export const useUserSelectedBranchLocation = () => {
    const selectedLocation = useSelector(state => {
        const _selectedLocation = state.rootReducer.selectedLocation.value;
        if (!_selectedLocation) {
          const _selectedLocationFromStorage = getFromLocalStorage();
          return _selectedLocationFromStorage;
        }
        return _selectedLocation;
        
})
    const dispatch = useDispatch();

    const getSelectedBranchLocation = () => {
        return getFromLocalStorage();
    }

    const selectBranchLocation = (location) => {
        if (!location) return;
        dispatch(set(location));
        setOnLocalStorage(location);
    }
    const unSetBranchLocation = () => {
        dispatch(unSet());
        clearOnLocalStorage();
    }

    return {
        selectedLocation,
        selectBranchLocation,
        unSetBranchLocation,
        getSelectedBranchLocation
    }
}